import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "../src/config/i18n";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import { Authenticator } from "@aws-amplify/ui-react";
import Navigation from "./routes/Navigation";
import { ToastContainer } from "react-toastify";
import "./utils/amplifyInit";

import ForceReloadToast from "./components/utils/ForceReloadToast";
import { setupGlobalErrorHandlers } from "./setupGlobalErrorHandlers";
import { ChatUIProvider } from "./components/UmmIAChatAI/ChatUIContext";
import { ErrorBoundaryWithAuth } from "./ErrorBoundaryWithAuth";

function ensureSingleMount(rootId = "root") {
  const el = document.getElementById(rootId);
  if (!el) throw new Error(`#${rootId} not found`);
  const markerKey = "__app_root_mounted__";
  if ((el as any)[markerKey]) {
    console.warn("App root ya fue montado (evitado).");
    return null;
  }
  (el as any)[markerKey] = true;
  return el;
}

localStorage.debug = "socket.io*";

const allowedDomains = [
  "https://cl-qa.ummia.ai/",
  "https://cl-dev.ummia.ai/"
];

if (process.env.NODE_ENV === "production" && !allowedDomains.includes(`${window.location.origin}/`)) {
  console.log = () => {};
  console.debug = () => {};
}

setupGlobalErrorHandlers();

const container = ensureSingleMount("root");
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      {/* IMPORTANTE: ForceReloadToast está fuera del ErrorBoundary para que SIEMPRE esté montado */}
      <ForceReloadToast />

      <Authenticator.Provider>
        <ErrorBoundaryWithAuth>
          <ChatUIProvider>
            <Navigation />               
          </ChatUIProvider>
        </ErrorBoundaryWithAuth>
      </Authenticator.Provider>

      {/* Mantener ToastContainer también fuera para que siempre pueda mostrar notificaciones */}
      <ToastContainer position="top-center" newestOnTop={true} />
    </React.StrictMode>
  );
}
